import React, { Component } from 'react';
import classnames from 'classnames';

import { loadingStatuses } from './loadingStatuses';
import { fieldsTypes, presetNames } from 'config/constants';
import { renderFieldCell } from 'components/FieldColumns/fieldTypes';

class ScrollableTableRow extends Component {
  render() {
    const {
      loadedRowsMap,
      style,
      rowIndex,
      columns,
      data,
      fixedCellWidth,
      isRowSelected,
      isFirstRowSelected,
      onRowClick,
      uniqueField,
      isRowClickable,
    } = this.props;

    const isRowSelectedVal = isRowSelected(rowIndex);
    const isFirstRowSelectedVal = isFirstRowSelected(rowIndex);
    const isLoaded = loadedRowsMap[rowIndex] === loadingStatuses.STATUS_LOADED;

    const extendClass = this.defineExtendClass();

    let backStyle = {
      position: 'absolute',
      width: '100%',
      height: style.height ? style.height : 36,
    };

    return (
      <div
        style={{ ...style }}
        className={classnames({
          'body-row': true,
          even: rowIndex % 2 === 0,
          'body-row-selected': isRowSelectedVal,
          'body-row-selected-first': isFirstRowSelectedVal,
        })}
        onClick={
          isRowClickable
            ? (e) => onRowClick(e, data[rowIndex][uniqueField], 0)
            : undefined
        }
      >
        <div className="body-row-back" style={backStyle} />
        <div
          className={classnames('body-cell', 'body-cell-fixed', extendClass)}
          style={{ width: fixedCellWidth - 1 }}
          onClick={
            isRowClickable
              ? (e) => {
                  e.stopPropagation();
                  onRowClick(e, data[rowIndex][uniqueField], 0);
                }
              : undefined
          }
        >
          <div className={classnames('body-cell-fixed-newline', extendClass)}>
            @#$
          </div>
          <div>{rowIndex + 1}</div>
        </div>

        {columns.map((column, colIndex) => {
          if (isLoaded) {
            const currentCell = data[rowIndex].columns[column.index];
            if (!currentCell) {
              return null;
            }

            return (
              <div
                key={`Row${rowIndex}-Col${colIndex}`}
                style={{ width: column.width || '200px' }}
                className={classnames('body-cell', extendClass)}
                onClick={
                  isRowClickable
                    ? (e) => {
                        e.stopPropagation();
                        onRowClick(e, data[rowIndex][uniqueField], colIndex);
                      }
                    : undefined
                }
              >
                {this.renderFieldValue(currentCell.value, column)}
              </div>
            );
          } else {
            return (
              <div
                key={`Row${rowIndex}-Col${colIndex}`}
                style={{ width: column.width || '200px' }}
                className="body-cell"
              >
                <div className="body-cell-preview" />
              </div>
            );
          }
        })}
      </div>
    );
  }

  renderFieldValue = (value, column) => renderFieldCell(value, column, this.props);

  defineExtendClass = () => {
    const { rowIndex, columns, data, rowHeightPreset } = this.props;
    let extendClass = '';
    const makeExtendClass = (preset) => `${preset}-height`;
    if (rowHeightPreset) {
      extendClass += makeExtendClass(rowHeightPreset);

      if (rowHeightPreset === presetNames.mediumIfPhoto) {
        const photoColumns = columns.filter(
          (column) => column.type === fieldsTypes.PHOTO,
        );
        if (photoColumns.length) {
          if (!data[rowIndex]) {
            // case when data not loaded yet
            extendClass = '';
          } else {
            // try to find photo with url, if it exist need medium height
            photoColumns.forEach((photoColumn) => {
              const column = data[rowIndex].columns[photoColumn.index];
              const value = column && column.value;
              if (value && typeof value === 'string' && value !== '') {
                extendClass = makeExtendClass(presetNames.medium);
              }
            });
          }
        } else {
          extendClass = '';
        }
      }
    }
    return extendClass;
  };
}

export default ScrollableTableRow;
